import type { NoSpenderListProjection } from '@api'
import type { Row } from '@tanstack/table-core'

import EditIcon from '@/assets/icons/icon-edit.svg'
import EyeIcon from '@/assets/icons/icon-eye.svg'
import ExpandMoreIcon from '@/assets/icons/icon-more.svg'
import TrashIcon from '@/assets/icons/icon-trash.svg'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx'

export interface NoSpendersActionButtonProps {
  row: Row<NoSpenderListProjection>
  onViewFans: (list: NoSpenderListProjection) => void
  onEdit: (list: NoSpenderListProjection) => void
  onDelete: (list: NoSpenderListProjection) => void
}

export const NoSpendersActionButton = ({
  row,
  onViewFans,
  onEdit,
  onDelete,
}: NoSpendersActionButtonProps) => {
  const itemClassNames =
    'h-[32px] gap-[8px] rounded-[6px] px-[16px] py-[8px] hover:bg-primary-500 hover:text-neutral-default disabled:opacity-60'

  return (
    <div className="flex justify-end gap-8">
      <DropdownMenu>
        <DropdownMenuTrigger testId="list-actions-button">
          <ExpandMoreIcon className="h-5 w-5" />
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="w-50 px-[5px] py-[8px]"
        >
          <DropdownMenuItem
            onClick={() => onViewFans(row.original)}
            className={itemClassNames}
            testId="view-fans-option"
          >
            <EyeIcon className="h-4 w-4" />
            View Fans
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => onEdit(row.original)}
            className={itemClassNames}
            testId="edit-list-option"
          >
            <EditIcon className="h-4 w-4" />
            Edit
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => onDelete(row.original)}
            className={itemClassNames}
            testId="delete-list-option"
          >
            <TrashIcon className="h-4 w-4" />
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
